import { useState } from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import { Confirm, SaveButton, Toolbar, useRecordContext } from 'react-admin';
import PropTypes from 'prop-types';
import { CustomConfirmContent } from '@/components/global/buttons/CustomConfirmContent';
import { globalStyles } from '@/themes/commonStyles/global.js';

export default function ConfirmToolbar({ onSubmit, shouldDisplay, message, preventDefault = false }) {
    const [open, setOpen] = useState(false);
    const { getValues, handleSubmit } = useFormContext();
    const { isValid, isLoading } = useFormState();
    const record = useRecordContext();

    const handleClick = event => {
        const formValues = getValues();
        if (isValid && shouldDisplay?.(formValues, record)) {
            event.preventDefault();
            setOpen(true);
            return;
        }
        if (preventDefault) {
            event.preventDefault();
            handleSubmit(onSubmit)();
        }
    };

    const handleConfirm = () => {
        setOpen(false);
        handleSubmit(onSubmit)();
    };

    const handleClose = () => setOpen(false);

    return (
        <Toolbar>
            <SaveButton onClick={handleClick} />
            <Confirm
                isOpen={open}
                content={<CustomConfirmContent content={message} handleDialogClose={handleClose} handleConfirm={handleConfirm} loading={isLoading} />}
                onConfirm={handleConfirm}
                onClose={handleClose}
                sx={{ ...globalStyles.customConfirmDialog }}
            />
        </Toolbar>
    );
}

ConfirmToolbar.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    shouldDisplay: PropTypes.func,
    preventDefault: PropTypes.bool,
    message: PropTypes.string,
};
